export class BooleanEncoder {
    static encode(value) {
        return String(Number(value));
    }
    static decode(value) {
        /*                                        */
        return value === '1';
    }
}
